import { memo } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

import { type AutomationRun } from '~/hooks/queries/automations/usePrivateAutomationRunsList';

const automationRunStatusDotVariants = tailwindVariants({
  base: 'size-1.5 shrink-0 rounded-full',
  variants: {
    status: {
      completed: 'ads:bg-ads-grass-9 bg-grass-9',
      failed: 'ads:bg-error bg-flash-9',
      skipped: 'ads:bg-ads-gray-8 bg-gray-8',
      started: 'ads:bg-ads-altitude-9 bg-altitude-9',
    } satisfies Record<AutomationRun['status'], string>,
  },
});

export type AutomationRunStatusDotProps = {
  status: AutomationRun['status'];
};

export const AutomationRunStatusDot = memo(({ status }: AutomationRunStatusDotProps) => (
  <span aria-hidden className={automationRunStatusDotVariants({ status })} />
));

AutomationRunStatusDot.displayName = 'AutomationRunStatusDot';
